export default __webpack_public_path__ + "static/media/Sinaly.3eb020c4.jpg";